import ServiceWrapper from "Services/ServiceWrapper";
import AuthManager from "Common/AuthManager";
import AppSettings from "Settings/AppSettings";
import gmsConfig from "Settings/AppSettings";
import { TCreateModel, TCreateSubmodel } from "Pages/GMS/ABTesting/types/ab";
import { RecommenderLogsResponse } from "../Types";

const GENERATE_END_POINT: string = '/ars/generate';
const RECOMMENDER_GENERATE_END_POINT: string = 'recommender/generate';
const PROMOTE_END_POINT: string = 'recommender/promote';
const DEPLOY_END_POINT: string = '/ars/deploy';
const LOG_DETAIL_END_POINT: string = '/ars/logs';
const ALL_LOGS_END_POINT = 'ars/merchant_logs';
const RECOMMENDER_END_POINT = 'recommender/model';
const APPLET_END_POINT = 'recommender/applet';

const BASE_URL = AppSettings.PROMOTION_API;

const API_END_URL = gmsConfig.GMS_BACKEND_API_URL;



export const generateRecommendations = async (type: string, userName: string, channelId: string) => {
    try {
        const response = await ServiceWrapper.doPost(
            `${BASE_URL}${GENERATE_END_POINT}/${channelId}`,
            {
                "type": type,
                "user_name": userName
            },
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (e) {
        return null;
    }
}

export const generateRecommender = async (modelIds: string[], channelId: string) => {
    try {
        const response = await ServiceWrapper.doPost(
            `${API_END_URL}${RECOMMENDER_GENERATE_END_POINT}`,
            {
                "models": modelIds,
                "channel": channelId
            },
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (e) {
        return null;
    }
}

export const getLiveModels = async (channelId: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${API_END_URL}recommender/live_models/${channelId}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const promoteModel = async (payload: AppletPayload) => {
    try {
        const response = await ServiceWrapper.doPost(
            `${API_END_URL}${PROMOTE_END_POINT}`,
            payload,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (e) {
        return null;
    }
}

export const deployRecommendations = async (userName: string, channelId: string) => {
    try {
        const response = await ServiceWrapper.doPost(
            `${BASE_URL}${DEPLOY_END_POINT}/${channelId}`,
            {
                "type": 'ARS Deployment',
                "user_name": userName
            },
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (e) {
        return null;
    }
}

export const getLogDetail = async (logId: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${BASE_URL}${LOG_DETAIL_END_POINT}/${logId}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const getAllLogs = async (channelId: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${BASE_URL}${ALL_LOGS_END_POINT}/${channelId}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const getRecommenderLogs = async (channelId: string, paginationParams: TPaginationParams) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${API_END_URL}${RECOMMENDER_END_POINT}/list/${channelId}?page=${paginationParams.page}&per_page=${paginationParams.per_page}&sort_by=${paginationParams.sort_by}&sort_by_order=${paginationParams.sort_by_order}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return error;
    }
}

export const getCategoryTypes = async (industryId: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${API_END_URL}categorytype/getbyindustryid/${industryId}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return error;
    }
}

export const getCategories = async (industryId: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${API_END_URL}category/getbyindustryid/${industryId}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return error;
    }
}

export const createRecommenderModel = async (data: TCreateModel) => {
    try {
        const response = await ServiceWrapper.doPost(
            `${API_END_URL}${RECOMMENDER_END_POINT}`,
            data,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return error;
    }
}

export const cloneRecommenderModel = async (data: { model_id: string, model_name?: string }) => {
    try {
        const response = await ServiceWrapper.doPost(
            `${API_END_URL}${RECOMMENDER_END_POINT}/clone`,
            data,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return error;
    }
}

export const createRecommenderSubmodel = async (model_id: string, data: TCreateSubmodel) => {
    try {
        const response = await ServiceWrapper.doPost(
            `${API_END_URL}${RECOMMENDER_END_POINT}/${model_id}/submodel`,
            data,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return error;
    }
}

export const deleteRecommenderModel = async (modelId: string) => {
    try {
        const response = await ServiceWrapper.doDelete(
            `${API_END_URL}${RECOMMENDER_END_POINT}/${modelId}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return error;
    }
}
export const getAppletList = async (channelId: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${API_END_URL}${APPLET_END_POINT}/list/${channelId}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return error;
    }
}

export const getDefaultModelOfApplet = async (appletId: string, channelId: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${API_END_URL}${RECOMMENDER_END_POINT}/default/${appletId}?channelId=${channelId}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return error;
    }
}

export const getModelData = async (modelId: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${API_END_URL}${RECOMMENDER_END_POINT}/${modelId}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return error;
    }
}


export const updateRecommenderModel = async (data: RecommenderLogsResponse) => {
    try {
        const response = await ServiceWrapper.doPut(
            `${API_END_URL}${RECOMMENDER_END_POINT}/${data?.model_id}`,
            data,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return error;
    }
}

export const updateAppletPlacementNote = async (applet: string, channelId: string, placementNote: string) => {
    try {
        const response = await ServiceWrapper.doPost(
            `${API_END_URL}${APPLET_END_POINT}/${channelId}/${applet}`,
            { placement_note: placementNote },
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return error;
    }
}

